import React, { lazy, useState } from 'react';
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import Box from '@material-ui/core/Box';

import { hasValue } from 'globalutils/fmUtils';
import { COOKIE_AUTH_DETAILS } from 'globalconfig/constants/keys';
import { getCookie } from 'globalservices/cookie';
import RenderComponent from './RenderComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;

const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const ErrorIcon = lazy(() => import(`globalcomponents/ErrorIcon/${layout}`));
const SuccessIcon = lazy(() => import(`globalcomponents/SuccessIcon/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));

const AddForm = ({
  apiStatus,
  handleAddLog,
  callback,
  drivers,
  vehicleList,
  Styled,
  theme,
  history,
  i18n
}) => {
  const token = getCookie(COOKIE_AUTH_DETAILS);
  const apiId = 'addLog';
  const hasApiStatus = hasValue(apiStatus.status, 'api', apiId);

  const [openCallback, setOpenCallback] = useState(false);
  const [removeValues, setRemoveValues] = useState('false');
  const [initialValues, setInitialValues] = useState({
    driverId: '',
    vehicleName: '',
    date: '',
    logData: ''
  });

  const [ModalListObject, setModalListObject] = useState({
    header: '',
    content: () => (
      <Button
        type="submit"
        label={i18n.t('common.ok')}
        onClick={() => setOpenCallback(false)}
      />
    )
  });

  const fleetVehicleList = vehicleList?.length
    ? vehicleList.map((item) => ({
      label: item.name,
      value: item.vehicleId
    }))
    : [];

  const addLogsCallback = (type, message) => {
    setModalListObject({
      header: '',
      content: () => (
        <div className="successpopup">
          {type === 'error' ? <ErrorIcon /> : <SuccessIcon />}
          <h2>{i18n.t(message)}</h2>
          <div className="deletePopupBtn">
            <Button
              type="submit"
              label={i18n.t('common.ok')}
              onClick={() => {
                setRemoveValues('true');
                setOpenCallback(false);
              }}
            />
          </div>
        </div>
      )
    });
    setOpenCallback(true);
  };

  const handleSubmit = (fields) => {
    const data = {
      driverId: fields.driverId.value,
      driverName: fields.driverId.label,
      date: fields.date,
      logData: fields.logData[0],
      vehicleName: fields.vehicleName.label
    };

    const fileStatus = document
      ?.querySelector('span.filepond--file-status-main')
      ?.innerText;

    if (fileStatus === '') {
      setRemoveValues('false');
      handleAddLog({ data: { data }, apiId, callback: addLogsCallback });
    }
  };

  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Styled.Wrapper>
        <Form
          type="server"
          direction="row"
          initialValues={initialValues}
          RenderComponent={RenderComponent}
          handleOnSubmit={handleSubmit}
          customProps={{
            hasApiStatus,
            drivers,
            history,
            fleetVehicleList,
            i18n,
            removeValues
          }}
          validationSchema={object().shape({
            driverId: string()
              .nullable()
              .required(i18n.t('common.fieldRequiredMessage')),
            vehicleName: string().required(i18n.t('common.fieldRequiredMessage')),
            date: string().required(i18n.t('common.fieldRequiredMessage')),
            logData: string().required(i18n.t('common.fieldRequiredMessage'))
          })}
        />
        <Modal
          open={openCallback}
          setOpen={setOpenCallback}
          data={ModalListObject}
          isSuccess
          disableEscapeKeyDown
          disableBackdropClick
        />
      </Styled.Wrapper>
    </Box>
  );
};

AddForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  handleAddLog: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  drivers: PropTypes.object.isRequired,
  vehicleList: PropTypes.array.isRequired,
  Styled: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired
};

export default AddForm;
